<template>
  <tr>
    <th>
      미확인 알림
      <br />(snooze)
    </th>
    <td>
      <span v-if="snoozeMax">{{snoozeMax}}회 : 최초 전송 시간 이후 {{snoozeInterval}}시간 간격</span>
      <span v-else>-</span>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    snoozeMax: Number,
    snoozeInterval: Number
  }
};
</script>

<style>
</style>